import React from 'react';
import _ from 'lodash';

import WidgetCard from './WidgetCard/WidgetCard';
import AdCard from './WidgetCard/AdCard';
import reducerStore from '../../reducers/reducerStore';
import competitionSlide from '../Slide/CompetitionSlide';

import './CreateWidget.scss';

class CreateWidget extends React.Component {
    renderReportCards(arr) {
        return arr.map((item, index) => {
            if (item.id === 'competition') {
                return (
                    <WidgetCard
                        key={`${item.id}-${index}`}
                        item={item}
                        onClick={(id) => {
                            reducerStore.dispatch({ type: 'SET_NEW_COMPETITION_SLIDE' });
                            reducerStore.dispatch({ type: 'ADD WIDGET', widget: competitionSlide.generateCompetitionWidgets(), slideId: this.props.editingSlide });
                            this.props.onChange(id);
                        }}
                    />
                );
            }

            return (
                <WidgetCard
                    key={`${item.id}-${index}`}
                    item={item}
                    onClick={this.props.onChange}
                />
            );
        });
    }

    render() {
        return (
            <div className="create-widget-panel">
                <div className='create-widget-title'>
                    <h1>Välj en Widgettyp</h1>
                    <p>Du kan alltid välja att byta senare.</p>
                </div>
                <div className='report-modul-container'>
                    <div className='report-cards-container'>
                        <h4>Sälj</h4>
                        <div className='widget-card-grid'>
                            {this.renderReportCards(this.props.reports.sales)}
                        </div>
                    </div>
                    <div className='report-cards-container'>
                        <h4>Marknad</h4>
                        <div className='widget-card-grid'>
                            {this.renderReportCards(this.props.reports.marketing)}
                        </div>
                    </div>
                </div>
                <div className='report-modul-container'>
                    {this.props.reports.custom.length > 0 && <div className='report-cards-container'>
                        <h4>Custom widgets</h4>
                        <div className='widget-card-grid custom-widget-grid'>
                            {this.renderReportCards(this.props.reports.custom)}
                        </div>
                    </div>}
                    <div className='report-cards-container'>
                    </div>
                    <div className='report-cards-container'>
                        <div className='widget-card-grid'
                            style={{ marginTop: '55px', gridTemplateColumns: '1fr' }}
                        >
                            <AdCard
                                title='Anpassa din UpsalesTV'
                                body='Bygg dina egna widgets och visa data från dina favorittjänster.'
                                linkText='Kontakta Upsales Support'
                                link='mailto:support@upsales.com'
                                color='#4B5562'
                                imgSrc='/client/assets/ad-img.png'
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

// CreateWidget.propTypes = {
//     onChange: React.PropTypes.func.isRequired,
// };

export default CreateWidget;



/** WEBPACK FOOTER **
 ** ./client/components/SettingsModal/CreateWidget.jsx
 **/